// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".components-panel__body .color-select {\n  display: flex;\n  align-items: center;\n}\n.components-panel__body .color-select .components-base-control {\n  flex-grow: 1;\n  margin-right: 15px;\n}\n.components-panel__body .color-select .components-base-control .components-base-control__field {\n  margin-bottom: 0;\n}\n.components-panel__body .color-select .color-circle {\n  flex-shrink: 0;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
